import { theme } from 'antd';

export const themeConfig = {
	token: {
		fontFamily: 'Montserrat, serif',
	},
	components: {
		Button: {
			colorPrimary: '#ff6a95',
			algorithm: true,
		},
		Select: {
			colorPrimary: '#ff6a95',
			algorithm: true,
			borderRadius: 4,
		},
		Radio: {
			colorPrimary: '#ff6a95',
			algorithm: true,
		},
		Checkbox: {
			colorPrimary: '#ff6a95',
			algorithm: true,
		},
		Input: {
			colorPrimary: '#eb2f96',
			algorithm: true,
			borderRadius: 4,
		},
		Pagination: {
			colorPrimary: '#eb2f96',
			algorithm: true,
			borderRadius: 4,
		},
		Spin: {
			colorPrimary: '#eb2f96',
			algorithm: true,
		},
		Menu: {
			colorPrimary: '#eb2f96',
			algorithm: true,
		},
		DatePicker: {
			colorPrimary: '#eb2f96',
			algorithm: true,
		},
	},
	algorithm: theme.defaultAlgorithm,
};
